import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

interface MenuList {
  function: (value: string) => void;
  content?: JSX.Element;
  allow?: boolean;
  disabled?: boolean;
  id: string;
}

interface PositionInterface {
  top: string;
  left: string;
}

/**
 * Drop Down function component
 * @param {any} param0 - The param0
 * @param {any} param0.list - The list prop
 * @param {any} param0.icon - The icon prop
 */
function DropDownMenu({ list, icon }: { list: MenuList[]; icon: JSX.Element }) {
  const reference = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const { i18n } = useTranslation();
  const [position, setPosition] = useState<PositionInterface>({
    top: '0px',
    left: '0px',
  });

  /**
   * Click the drop down function
   * @param {any} event - The mouse event
   */
  const openDropdown = (event: React.MouseEvent) => {
    event.stopPropagation();
    const isRTL = i18n.dir() === 'rtl';
    const rect = event.currentTarget.getBoundingClientRect();

    setPosition({
      left: isRTL ? `${rect.left}px` : `${rect.right - 100}px`,
      top: `${rect.bottom + 5}px`,
    });
    setOpen(!open);
  };
  /**
   * Handle the close th drop down function
   * @param {any} event - The mouse event
   */
  const handleClickOutside = (event: MouseEvent) => {
    if (reference.current && !reference.current.contains(event.target as Node)) {
      setOpen(false);
    }
  };
  useEffect((): void => {
    document.addEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="drop-down">
      <div className="drop-down-title" onClick={openDropdown} role="presentation">
        {icon}
      </div>
      {open &&
        ReactDOM.createPortal(
          <div
            className="drop-down-content"
            ref={reference}
            style={{
              top: position.top,
              left: position.left,
              position: 'fixed',
              right: 'auto',
            }}
            dir={i18n.dir()}>
            {list.map(
              (value, index) =>
                value.allow && (
                  <>
                    {index !== 0 && <hr />}
                    <div
                      className={`drop-down-content-list-item ${value.disabled ? 'disabled' : ''}`}
                      onClick={(event) => {
                        event.stopPropagation();
                        value.function(value.id);
                      }}
                      role="presentation">
                      {value.content}
                    </div>
                  </>
                ),
            )}
          </div>,
          document.body,
        )}
    </div>
  );
}

export default DropDownMenu;
